import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ellipsis" }

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DropDown',
  props: /*#__PURE__*/_mergeModels({
    options: {},
    optionLabel: { default: '' },
    optionValue: { default: '' },
    label: { default: '' },
    className: { default: '' },
    popupClass: { default: '' },
    clearable: { type: Boolean, default: false }
  }, {
    "modelValue": {required: true},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const model = _useModel(__props, "modelValue");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = __props;

const hasValue = computed(() => {
  return model && model.value;
});

function clearValue() {
  model.value = undefined;
}


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    outlined: "",
    dense: "",
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    options: _ctx.options,
    "option-label": _ctx.optionLabel,
    "option-value": _ctx.optionValue,
    label: _ctx.label,
    class: _normalizeClass(`iodine-dropdown ${_ctx.className}`),
    "dropdown-icon": "fa-duotone fa-solid fa-circle-caret-down",
    for: "dropdown",
    "popup-content-class": _ctx.popupClass
  }, {
    "selected-item": _withCtx((scope) => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.optionLabel ? scope.opt[_ctx.optionLabel] : scope.opt), 1)
    ]),
    append: _withCtx(() => [
      (hasValue.value && _ctx.clearable)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 0,
            name: "fa-regular fa-circle-x",
            onClick: _withModifiers(clearValue, ["stop","prevent"]),
            class: "cursor-pointer"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "options", "option-label", "option-value", "label", "class", "popup-content-class"]))
}
}

})